import { AxiosPost } from "../AxiosWrapper";
import { DOCUMENTSTORE_SERVICE_URL } from "../../constants/ServiceUrls";

export const getDocumentActivityHistory = (documentIdentifier) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Audit/GetDocumentActivityHistory`,
    {
      documentIdentifier,
    }
  );
};

export const auditDocumentView = (
  documentIdentifier,
  folderId,
  documentTypeId
) => {
  return AxiosPost(`${DOCUMENTSTORE_SERVICE_URL}api/Audit/AuditDocumentView`, {
    documentIdentifier,
    folderId,
    documentTypeId,
  });
};

export default { getDocumentActivityHistory, auditDocumentView };
